<ng-template #content_no_config_bill_settings let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}">
        <div class="side_popup_header">
            <span>{{localService.languageContent.table.action}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="max-height: calc(100vh - 130px);" *ngIf="item">
            <div class="row">
                <div class="col-12">
                    <app-label [Text]="'Before Receipt'" />
                    <textarea [rows]="5" [placeholder]="'Type something...'" [(ngModel)]="item.v1">
                    </textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-label [Text]="'After Receipt'" />
                    <textarea [rows]="5" [placeholder]="'Type something...'" [(ngModel)]="item.v2">
                    </textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-label [Text]="'Receipt Font Size'" />
                    <input type="number" [(ngModel)]="item.v3" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-label [Text]="'Receipt Width'" />
                    <input type="number" [(ngModel)]="item.v4" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-label [Text]="'Receipt Line Height'" />
                    <input type="number" [(ngModel)]="item.v5" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="adjust_checkbox" style="font-weight: normal;margin-left: 20px;">
                        <input type="checkbox" [(ngModel)]="item.isSelected" />
                        <span>Is receipt two lines?</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onSave()">
                        {{localService.languageContent.common.save}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>